import { axios, HOST, config } from "./settiing";

export default {
  getApprovementBetween(start, end, params) {
    let query = "";
    Object.keys(params).forEach((k) => (query = query + `${k}=${params[k]}&`));
    return axios.get(
      `${HOST}/resource/web/approvement/${start}/${end}?${query}`,
      config
    );
  },
  getApprovementInfoById(id) {
    return axios.get(`${HOST}/resource/approvement/${id}`, config);
  },
  getApprDriveLog(driveLogId) {
    return axios.get(
      `${HOST}/resource/approvement/driveLog/${driveLogId}`,
      config
    );
  },
  getApprDetailList(approvementId) {
    return axios.get(
      `${HOST}/resource/approvement/detail/${approvementId}`,
      config
    );
  },
  getApprDocumentList(customerId, approvementId) {
    return axios.get(
      `${HOST}/resource/document/approvement/${customerId}/${approvementId}`,
      config
    );
  },
  /* 결재 */
  customerTypeAppr(data) {
    return axios.post(
      `${HOST}/resource/approvement/customerType`,
      data,
      config
    );
  },
  groupAppr(data) {
    return axios.post(`${HOST}/resource/approvement/group`, data, config);
  },
  voucherAppr(data) {
    return axios.post(`${HOST}/resource/approvement/voucher`, data, config);
  },
  voucherExpirationDate(appId, baseDate) {
    return axios.get(
      `${HOST}/resource/approvement/expirationDate/${appId}/${baseDate}`,
      config
    );
  },
};
